import { render, staticRenderFns } from "./PageEnd.vue?vue&type=template&id=bb21eb7e&scoped=true"
import script from "./PageEnd.vue?vue&type=script&lang=js"
export * from "./PageEnd.vue?vue&type=script&lang=js"
import style0 from "./PageEnd.vue?vue&type=style&index=0&id=bb21eb7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb21eb7e",
  null
  
)

export default component.exports